/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Arts_Music_Design_Fashion22Inputs */

const en_job_form_enum_arts_music_design_fashion22 = /** @type {(inputs: Job_Form_Enum_Arts_Music_Design_Fashion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arts, Music, Design and Fashion`)
};

const de_job_form_enum_arts_music_design_fashion22 = /** @type {(inputs: Job_Form_Enum_Arts_Music_Design_Fashion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst, Musik, Design und Mode`)
};

/**
* | output |
* | --- |
* | "Arts, Music, Design and Fashion" |
*
* @param {Job_Form_Enum_Arts_Music_Design_Fashion22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_arts_music_design_fashion22 = /** @type {((inputs?: Job_Form_Enum_Arts_Music_Design_Fashion22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Arts_Music_Design_Fashion22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_arts_music_design_fashion22(inputs)
	return en_job_form_enum_arts_music_design_fashion22(inputs)
});
export { job_form_enum_arts_music_design_fashion22 as "job_form_enum_ARTS_MUSIC_DESIGN_FASHION" }